import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import isBetween from "dayjs/plugin/isBetween";
import localizedFormat from "dayjs/plugin/localizedFormat";
import relativeTime from "dayjs/plugin/relativeTime";

import { Provider } from "jotai";
import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import z from "zod";

import { QueryProvider } from "@/providers/QueryProvider";

import { Toasts } from "./components/Toasts";
import { zodErrors } from "./helpers/forms";
import { RootPage } from "./pages/RootPage";
import { store } from "./store";

import "@kazaar-platform/design-system/style.css";
import "react-loading-skeleton/dist/skeleton.css";
import "./fonts.css";
import "dayjs/locale/de";
import "dayjs/locale/el";
import "dayjs/locale/en";
import "dayjs/locale/es";
import "dayjs/locale/fr";
import "dayjs/locale/hr";
import "dayjs/locale/it";
import "dayjs/locale/ja";
import "dayjs/locale/pl";
import "dayjs/locale/sl";
import "./index.css";
import "./instrument";
import { ThemeProvider } from "./providers/ThemeProvider";
import { TranslationProvider } from "./providers/TranslationProvider";

dayjs.extend(localizedFormat);
dayjs.extend(customParseFormat);
dayjs.extend(relativeTime);
dayjs.extend(isBetween);

z.config({
  customError: zodErrors,
});

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <StrictMode>
    <Provider store={store}>
      <QueryProvider>
        <TranslationProvider>
          <ThemeProvider>
            <RootPage />
            <Toasts />
          </ThemeProvider>
        </TranslationProvider>
      </QueryProvider>
    </Provider>
  </StrictMode>
);
